import React from 'react';
import './ButtonFooter.css';


function addTask(e) {
    e.preventDefault();
    document.getElementById("opacity-layer").style.display = "block";
    document.getElementById("create-task-popup").style.display = "flex";
}

function filterTasks(e) {
    e.preventDefault();
    document.getElementById("opacity-layer3").style.display = "block";
    document.getElementById("filter-categories-popup").style.display = "flex";
}



class ButtonFooter extends React.Component {
    render() {
        return (
            <div id="footer-container">
                <button className="icon-slide-left" id="addButton" onClick={addTask} ><span>Add Item</span></button>
                <button className="icon-slide-right" id="filterButton" onClick={filterTasks} ><span>Filter Items</span></button>
            </div>
        );
    }
}
export default ButtonFooter;